import GlobalTableGenerator from '../../../../../components/GlobalTableGenerator';
import { dailyViewTableHead } from '../utils/tableHeaders';

export default function DailyView() {
  const rows = [
    {
      id: 1,
      sl_no: 1,
      date: '2026-02-01',
      from_time: '10:00 AM',
      to_time: '11:00 AM',
      subject: 'Mathematics',
      lessons: 'Fractions',
      remarks: 'Good participation',
      timestamp: '2026-02-01 11:05:22',
    },
    {
      id: 2,
      sl_no: 2,
      date: '2026-02-02',
      from_time: '02:00 PM',
      to_time: '03:00 PM',
      subject: 'Science',
      lessons: 'Human Digestive System',
      remarks: 'Needs revision',
      timestamp: '2026-02-02 15:02:10',
    },
    {
      id: 3,
      sl_no: 3,
      date: '2026-02-03',
      from_time: '09:30 AM',
      to_time: '10:30 AM',
      subject: 'English',
      lessons: 'Grammar - Tenses',
      remarks: 'Homework assigned',
      timestamp: '2026-02-03 10:35:44',
    },
  ];

  return (
    <GlobalTableGenerator
      columns={dailyViewTableHead}
      rows={rows}
      TableStyle={{
        borderCollapse: 'collapse',
        '& .MuiTableCell-root': {
          border: '1px solid #ffffffff',
        },
      }}
      TableHeadStyle={{
        bgcolor: '#dadee2ff',
        '& .muitablecell-root': {
          fontweight: 600,
        },
      }}
    />
  );
}
